import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus, ValidationMessage } from '../../enum';

@Component({
  selector: 'app-add-update-reps',
  templateUrl: './add-update-reps.component.html',
  styleUrls: ['./add-update-reps.component.scss'],

  standalone: false,
})
export class AddUpdateRepsComponent implements OnInit {
  isVisibleRepsDrawer = true;
  isLoadingUpload = false;
  isLoadingOne = false;
  lightColorStyle: any;
  repsDrawerTitle: any = 'Edit Rep';
  uploadResult: any = null;
  uploadFlag: any = false;
  validationMessage = ValidationMessage;
  @Output() hideRepsDrawer = new EventEmitter();
  @Input() selectedRepsData: any;
  url: any;
  deleteIcon: any;
  userDetails: any;
  retailProgramsList:any[]=[]
  isRetailProgramsLoading: boolean = false;
  hasPermissionToPrograms: boolean = false;

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private msg: NzMessageService
  ) {
    // Initialize the reps form with validation rules
    _fS.repsForm_fb();
  }

  ngOnInit(): void {
    // This component is only used for editing existing reps
    if (this.selectedRepsData != null) {
      console.log(this.selectedRepsData);
      
      // Extract first and last name from repName field
      const repName = this.selectedRepsData.repName || this.selectedRepsData.investorDisplayName || '';
      
      // Clean and validate the repName
      const cleanRepName = repName ? repName.trim() : '';
      const nameParts = cleanRepName ? cleanRepName.split(/\s+/) : [];
      
      const firstName = nameParts.length > 0 ? nameParts[0] : '';
      const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
      
      // Truncate names if they exceed maximum length (50 characters)
      const maxLength = 50;
      const truncatedFirstName = firstName.length > maxLength ? firstName.substring(0, maxLength) : firstName;
      const truncatedLastName = lastName.length > maxLength ? lastName.substring(0, maxLength) : lastName;

      this._fS.repsForm.patchValue({
        repsProfile: this.selectedRepsData.profileImageUrl || '',
        linkedInProfilelnk: this.selectedRepsData.linkedInProfileUrl || '',
        title: this.selectedRepsData.title || '',
        location: this.selectedRepsData.location || '',
        firstName: truncatedFirstName,
        lastName: truncatedLastName,
        mobileNumber: this.formatPhoneNumberForDisplay(this.selectedRepsData.phoneNumber || this.selectedRepsData.mobileNumber || ''),
      });
      
      // Check if phone number is valid and show warning if not
      const phoneNumber = this.selectedRepsData.phoneNumber || this.selectedRepsData.mobileNumber || '';
      if (phoneNumber && !this.cleanPhoneNumber(phoneNumber).match(/^\d{10}$/)) {
        // console.warn('Invalid phone number format:', phoneNumber);
        // this._cS.displayMessage('warning', 'The phone number in the data appears to be invalid. Please update it.');
      }
      
      if (this.uploadFlag == false) {
        this.uploadResult = this.selectedRepsData.profileImageUrl;
      }
      if(this.selectedRepsData.isSupplierEdited) {
        this.getRetailProgramForSupplier();
      }

    }
  }

  onFileChanged(e: any) {
    let reader = new FileReader();
    if (
      e.target.files[0].length > 0 ||
      e.target.files[0].type === 'image/jpeg' ||
      e.target.files[0].type === 'image/png' ||
      e.target.files[0].type === 'image/jpg'
    ) {
      this.url = e.target.files[0];
      reader.readAsDataURL(this.url);
      reader.onload = () => {
        this.url = reader.result;
        this._fS.fileupload.set('File', e.target.files[0]);
        this._fS.fileupload.set('Screen', 'repsProfile');
        this.isLoadingUpload = true;
        this._cpS.fileUpload(this._fS.fileupload).subscribe(
          (response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this.uploadResult = response.result[0];
              this._cS.displayMessage('success', response.message);
              this.isLoadingUpload = false;
            } else {
              this._cS.displayMessage('error', response.message);
              this.isLoadingUpload = false;
            }
          },
          (error: any) => {
            // this._cS.displayMessage('error', error.message);
            this.isLoadingUpload = false;
          }
        );
      };
    } else {
      this.msg.error('File type is not allowed');
      this.url = null;
      this.uploadResult = null;
      this.isLoadingUpload = false;
    }
  }
  Onclick(e: any) {
    e.target.value = null;
  }

  retailProgramsChange(event: any, data: any) {
    data.isChecked = event;
  }

   //Code added by Dev for Retail
  getRetailProgramForSupplier() {
    this.isRetailProgramsLoading =  true;
    this._cpS.getRetailProgramForSupplier().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.retailProgramsList = [...response.result];
        
        if (
          this.selectedRepsData != null &&
          this.selectedRepsData.retailPrograms != null
        ) {
          const checkedIds = new Set(
            this.selectedRepsData.retailPrograms.map((p) => p.id)
          );
          
          // 2) Walk `retailsProgramList` and flip on `isChecked` whenever the ID is in that Set
          this.retailProgramsList.forEach((program) => {
            if (checkedIds.has(program.id)) {
              program['isChecked'] = true;
            }
          });
        }
        this.isRetailProgramsLoading = false
      }else{
        this.isRetailProgramsLoading = false
      }
    });
  }
  
 
  cleanPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) return '';
    // Remove all non-numeric characters
    return phoneNumber.replace(/\D/g, '');
  }
  
 
  formatPhoneNumberForDisplay(phoneNumber: string): string {
    if (!phoneNumber) return '';
    const cleanNumber = this.cleanPhoneNumber(phoneNumber);
    if (cleanNumber.length === 10) {
      return `(${cleanNumber.substring(0, 3)}) ${cleanNumber.substring(3, 6)}-${cleanNumber.substring(6, 10)}`;
    }
    return phoneNumber; // Return as-is if not a valid 10-digit number
  }
  
  removeLogo() {
    var requestBody = {
      screen: 'repsProfile',
      filename: this.uploadResult,
    };
    this._cpS.fileDelete(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);
        this.url = '';
        this.deleteIcon = false;
        this.uploadResult = null;
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }

  /**
   * Cancel editing and close the drawer
   */
  handleCancel() {
    this.isVisibleRepsDrawer = false;
    this.hideRepsDrawer.emit({ hide: this.isVisibleRepsDrawer, data: null });
    // Reset form when canceling
    this._fS.repsForm.reset();
    this.uploadResult = null;
  }

  broofa() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  async handleOk() {
    // Check if form is valid - this uses the validation from repsForm_fb
    if (this._fS.repsForm.invalid) {
      this._cS.markFormGroupTouched(this._fS.repsForm);
      return;
    }

    // Ensure we have selectedRepsData for editing
    if (!this.selectedRepsData || !this.selectedRepsData.id) {
      this._cS.displayMessage('error', 'No rep data selected for editing');
      return;
    }

    const formValue = this._fS.repsForm.value;
    let retailPrograms: any[] = [];
    if (this.retailProgramsList.length > 0) {
      retailPrograms = this.retailProgramsList.filter((program: any) => program.isChecked);
    }
            
    
    this.isLoadingOne = true;
    // const formData = new FormData();
    const requestBody = {
      Id: this.selectedRepsData.id,
      ProfileImageUrl: this.uploadResult || '',
      LinkedInProfileUrl: formValue.linkedInProfilelnk || '',
      Title: formValue.title || '',
      Location: formValue.location || '',
      FirstName: (formValue.firstName || '').trim(),
      LastName: (formValue.lastName || '').trim(),
      MobileNumber: (formValue.mobileNumber || '').trim(),
      SupplierId: this.selectedRepsData.supplierId,
      PhoneNumber: this.cleanPhoneNumber(formValue.mobileNumber || ''),
      retailPrograms: retailPrograms
    };
    this._cpS.updateReps(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);

        //hide rep drawer
        this.isVisibleRepsDrawer = false;
      
        // Emit the complete data to parent component
        this.hideRepsDrawer.emit({
          hide: this.isVisibleRepsDrawer,
          data: response.result,
        });
        
        this.isLoadingOne = false;
        
        // Reset form immediately (following the pattern used in other components)
        this._fS.repsForm.reset();
        this.uploadResult = null;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
}
